import WatchDemo from "./WatchDemo/WatchDemo";
import __collections from "assets/configs/collections.json";
import { ICollection, ICollectionItem, ICollectionItemObject, ICollectionItemSearch, ICollectionObject } from "Utils/Interfaces";


export const COMPONENTS_ARTICLES = {
    WatchDemo
}

export const SUGGESTED_ARTICLES: ICollectionItem[] = [
    __collections["1"].items["1"],
    __collections["1"].items["2"],
    __collections["2"].items["1"]
];

class Articles {

    private collections: ICollectionObject = __collections;

    /**
     * finds articles from the given text  
     * @param text string
     * @returns ICollectionItemSearch[]
     */
    find = (text: string): ICollectionItemSearch[] => {

        const results: ICollectionItemSearch[] = [];
        const words = text.match(/\b(\w+)\b/g);
        const noWords = (words?.length === 0);
        if(noWords) return results;

        const wordsStrRegex = `(${words?.join("|")})` || "";
        const regex = new RegExp(wordsStrRegex, "i");

        // collections
        Object.keys(this.collections).forEach((collectionId: string) => {
            const collection: ICollection = this.collections[collectionId];
            const items: ICollectionItemObject = collection.items;
            // collection items
            Object.keys(items).forEach((itemId: string) => {
                const item: ICollectionItem = collection.items[itemId];
                
                // initialize the main variables
                const title: string = item.title;
                const collectionTitle: string = collection.title;
                const collectionDescription: string = collection.description;
                const searchStr = `${title} ${collectionTitle} ${collectionDescription}`;
                const matched = regex.test(searchStr);
                if(matched) {
                    results.push({
                        ...item,
                        collectionTitle,
                        collectionDescription
                    });
                }
            });
        });

        return results;
    }

}


// export Articles class instance (singleton)
export const __articles = new Articles();